import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=3b1ecdb8&"
import script from "./navMenu.vue?vue&type=script&lang=ts&"
export * from "./navMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports